export default function insertInPayloadStart(
  currentPayload: string,
  newInfo: string,
) {
  return newInfo + '\n ' + currentPayload
}
